import React, { Component } from 'react'

import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        width: '24%'
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function VariantDetailRow({ title, values }) {
    return (
        <StyledTableRow>
            <StyledTableCell component="th" scope="row">
                {title}
            </StyledTableCell>
            {values.map((value, i) => (
                (value && (<StyledTableCell key={i} align="center">{value}</StyledTableCell>))
            ))}
        </StyledTableRow>
    )
}
